import { apiFetch } from './client';

export const getContexts = (params = {}) =>
  apiFetch(`/api/contexts?${new URLSearchParams(params)}`);

export const getContext = (id) => apiFetch(`/api/contexts/${id}`);

export const createContext = (body) =>
  apiFetch('/api/contexts', { method: 'POST', body: JSON.stringify(body) });

export const updateContext = (id, body) =>
  apiFetch(`/api/contexts/${id}`, { method: 'PATCH', body: JSON.stringify(body) });

export const getContextEntries = (id, params = {}) =>
  apiFetch(`/api/contexts/${id}/entries?${new URLSearchParams(params)}`);

export const getContextTasks = (id, params = {}) =>
  apiFetch(`/api/contexts/${id}/tasks?${new URLSearchParams(params)}`);

export const getContextTimeline = (id) => apiFetch(`/api/contexts/${id}/timeline`);

export const assignEntryContext = (entryId, contextId) =>
  apiFetch(`/api/entries/${entryId}/context`, {
    method: 'POST',
    body: JSON.stringify({ context_id: contextId }),
  });
